import type { PrescriptionItem, RestorationPlan } from "../../types/dental";
import { CrownToolbox } from "./CrownToolbox";
import { ImplantToolbox } from "./ImplantToolbox";
import { BridgeToolbox } from "./BridgeToolbox";
import { VeneerToolbox } from "./VeneerToolbox";
import { GenericToolbox } from "./GenericToolbox";

interface ProcedureToolboxProps {
  prescriptionItem: PrescriptionItem | null;
  plan: RestorationPlan | null;
  onCreatePlan: () => void;
  onUpdatePlan: (planId: string, updates: Partial<RestorationPlan>) => void;
  onGenerateCrown: () => void | Promise<void>;
  isGeneratingCrown?: boolean;
}

export function ProcedureToolbox({
  prescriptionItem,
  plan,
  onCreatePlan,
  onUpdatePlan,
  onGenerateCrown,
  isGeneratingCrown = false,
}: ProcedureToolboxProps) {
  if (!prescriptionItem) {
    return (
      <section className="procedure-toolbox-shell card">
        <h3>Procedure Toolbox</h3>
        <div className="prescription-empty">
          Select a prescription item to see its tools.
        </div>
      </section>
    );
  }

  if (!plan) {
    return (
      <section className="procedure-toolbox-shell card">
        <h3>Procedure Toolbox</h3>
        <div className="field-stack">
          <div className="prescription-empty">
            No restoration plan exists yet for this prescription.
          </div>
          <button className="primary-button" onClick={onCreatePlan}>
            Create Restoration Plan
          </button>
        </div>
      </section>
    );
  }

  return (
    <div className="procedure-toolbox-shell">
      {(() => {
        switch (prescriptionItem.procedureType) {
          case "crown":
            return (
              <CrownToolbox
                plan={plan}
                onUpdatePlan={onUpdatePlan}
                onGenerateCrown={onGenerateCrown}
                isGeneratingCrown={isGeneratingCrown}
              />
            );

          case "implant":
          case "custom_abutment":
            return <ImplantToolbox plan={plan} onUpdatePlan={onUpdatePlan} />;

          case "bridge":
            return <BridgeToolbox plan={plan} onUpdatePlan={onUpdatePlan} />;

          case "veneer":
            return <VeneerToolbox plan={plan} onUpdatePlan={onUpdatePlan} />;

          default:
            return <GenericToolbox plan={plan} onUpdatePlan={onUpdatePlan} />;
        }
      })()}
    </div>
  );
}